import React from 'react';
import { SvgBank } from '@grubhubprod/gh-cookbook-react';
import { BasePaymentMethodDisplay } from 'src/components/selfService/common/Balance/components/BasePaymentMethodDisplay/BasePaymentMethodDisplay';

export interface BankAccountDisplayProps {
  institutionName: string;
  accountName: string;
  accountNumberMask: string;
  isDefault: boolean;
  showBorder?: boolean;
}

export function BankAccountDisplay({
  institutionName,
  accountName,
  accountNumberMask,
  isDefault,
  showBorder = true,
}: BankAccountDisplayProps): JSX.Element {
  const primaryText = `${institutionName} •••• ${accountNumberMask}`;
  const secondaryText = accountName;

  return (
    <BasePaymentMethodDisplay
      icon={<SvgBank size="24px" />}
      primaryText={primaryText}
      secondaryText={secondaryText}
      isDefault={isDefault}
      showBorder={showBorder}
    />
  );
}
